module.exports = __webpack_public_path__ + "static/img/info04@2x.826ff634.png";